import React, { useEffect, useState, useMemo, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import HeaderTop from "../../Layout/HeaderTop";
import SideBar from "../../Layout/Sidebar/SideBar";
import { Link } from "react-router-dom";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Layout, Space } from "antd";
import FooterBottom from "../../Layout/FooterBottom";
import SideMenu from "../../Layout/SideMenu";

import {
  Container,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
} from "reactstrap";
import TableContainer from "../Util/TableContainer";
//import 'bootstrap/dist/css/bootstrap.min.css';
import { SelectColumnFilter } from "../Util/filters";
import axios from "../../api/axios";

const ShiftGroup = () => {

  const [data, setData] = useState([]);
  const ShiftGroupListURL = "/GetShiftGroupListFromCompanyId";
  const tableRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const doFetch = async () => {
      // const response = await fetch('https://randomuser.me/api/?results=100');
      const response = await axios.get(
        ShiftGroupListURL + "?CompanyId=" + localStorage.getItem("companyId")
      );
      console.log(response.data);
      response.data.shift();
      setData(response.data);
    };
    doFetch();
  }, []);

  const EditData = (id) => {
    //let { id} = data;
    // localStorage.setItem('EditUserId', id);
    //alert(id);
    navigate("/ShiftGroupMaster", { state: { id } });
  };

  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "#",
  //       accessor: "rowNum",
  //       disableFilters: true,
  //     },
  //     {
  //       Header: "Shift Group Name",
  //       accessor: "shiftGroupName",
  //       Filter: SelectColumnFilter,
  //       disableFilters: true,
  //     },
  //     {
  //       Header: "AssignShift",
  //       accessor: "assignShift",
  //       disableFilters: true,
  //     },
  //     {
  //       Header: "OT After Min",
  //       accessor: "otAfterMin",
  //       disableFilters: true,
  //     },
  //     {
  //       Header: "IsOTAllow",
  //       accessor: "isOTAllowStatus",
  //       Filter: SelectColumnFilter,
  //     },
  //     {
  //       Header: "IsCOFF",
  //       accessor: "isCOFFStatus",
  //       Filter: SelectColumnFilter,
  //     },

  //     {
  //       Header: "Unit",
  //       accessor: "unitName",
  //       Filter: SelectColumnFilter,
  //     },
  //     // {
  //     //   Header: 'Email',
  //     //   accessor: 'email',
  //     // },
  //     {
  //       Header: "Status",
  //       Filter: SelectColumnFilter,
  //       accessor: "status",
  //     },
  //     {
  //       Header: "Action", //() => null,
  //       id: "ShiftGroupId", // 'id' is required
  //       accessor: "shiftGroupId",
  //       disableFilters: true,
  //       Cell: ({ row }) => (
  //         <span {...row}>
  //           <button
  //             style={{ width: "40%", height: "40px", color: "green" }}
  //             onClick={(e) => {
  //               EditData(row.cells[8].value);
  //             }}
  //             className="btn"
  //           >
  //             <i className="fa fa-pencil-square-o"></i>
  //           </button>
  //           {/* &nbsp;
  //          <button style={{width:'40%', height:'40px' ,color:'red' }} onClick={(e) => {InActiveData(row.cells[4].value)}} className="btn" ><i className='fa fa-close'></i></button> */}
  //         </span>
  //       ),
  //     },
  //   ],
  //   []
  // );

  return (
    <>
  <div className="layoutContainer">
  <div className="row g-3">
                <div className="col-lg-10" style={{ textAlign: "Left" }}>
                  {" "}
                  <h4>
                    <b>ShiftGroup List</b>
                  </h4>
                </div>
                <div className="col-lg-2">
                  {/* <button onClick={(e) => {EditData(0)}}  className="btn btn-success">Add New (+)</button> */}
                  <button
                    onClick={(e) => {
                      EditData(0);
                    }}
                    className="btn btn-primary"
                  >
                    Add New (+)
                  </button>
                </div>
                <div className="col-lg-2">
                                  <DownloadTableExcel
                                    filename="Shift Group Table"
                                    sheet="Shift Group"
                                    currentTableRef={tableRef.current}
                                  >
                                    <button className="btn btn-success">
                                      Export to Excell
                                    </button>
                                  </DownloadTableExcel>
                                </div>
              </div>
              <div className="scollDiv mt-4">
                <table
                  ref={tableRef}
                  className="attendTable text-center"
                  style={{ width: "100%" }}
                >
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>Sr No.</td>
                      <td>Shift Group Name</td>
                      {/* <td>Company Name</td> */}
                      {/* <td>Assign Shift</td> */}
                      <td>OT After Min</td>                      
                      {/* <td>Is OT Allow</td>
                      <td>Is COFF</td>
                      <td>Unit</td> */}
                      <td>Status</td>
                      <td>Action</td>
                    </tr>

                    {data.map((att, index) => (
                      <>
                        <tr data-index={index}>
                          <td>{att.rowNum}</td>
                          <td>{att.shiftGroupName}</td>
                          {/* <td>{att.companyName}</td> */}
                          {/* <td>{att.assignShift}</td> */}
                          <td>{att.otAfterMin}</td>
                          {/* <td>{att.isOTAllowStatus}</td>
                          <td>{att.isCOFFStatus}</td>
                          <td>{att.unitName}</td> */}
                          <td>{att.status}</td>
                          <td>{<button
                              style={{ width: "40%", height: "40px", color: "green" }}
                              onClick={(e) =>
                                EditData(att.shiftGroupId)
                              }
                              className="btn"
                            >
                            <i className="fa fa-pencil-square-o"></i>
                            </button>}  
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
    </>
  );
};

export default ShiftGroup;
